import angular from 'angular';
import ReportingCtrl from './ReportingCtrl';
import ReportingService from './ReportingService';

export default angular
  .module('reporting', [])
  .config(function routes($stateProvider) {
    $stateProvider
      .state('reporting-opm', {
        url: '/reporting/opm',
        template: require('./opm.html'),
        controller: ReportingCtrl,
        controllerAs: 'ctrl',
      })
      .state('reporting-measurement', {
        url: '/reporting/measurement',
        template: require('./measurement.html'),
        controller: ReportingCtrl,
        controllerAs: 'ctrl',
      })
  })
  .service('ReportingService', ReportingService)
  .name;



// WEBPACK FOOTER //
// ./src/Reporting/index.js